import { IconSearch } from "@tabler/icons-react";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, TextInput, Textarea, Button, Center, Box, Progress } from "@mantine/core";
import { Table, Flex, Tag, Space, message } from 'antd';
import Topnavbar from "../Layouts/Topnavbar";
import { Userauthcontexthooks } from "../Hooks/Userauthcontexthooks";
import { useState, useEffect } from "react";
import { ChangeMpin, ChangePassword, Sendotp } from "../apicall";
import { useNavigate } from 'react-router-dom';
import { IconCheck, IconX } from "@tabler/icons-react";




const Accountsetings = () => {
    const { dispatch } = Userauthcontexthooks();
    const Navigate = useNavigate();
    const [changempin, setChangempin] = useState({
        purpose: 'Change MPIN',
        newMpin: '',
        confirmNewMpin: '',
        otp: ''
    })
    const [changepassword, setChangepassword] = useState({
        purpose: 'Change Password',
        newPassword: '',
        confirmNewPassword: '',
        otp: ''
    })
    const [otploading, setotploading] = useState(false);
    const [mpinloading, setmpinloading] = useState(false);
    const [passwordloading, setpasswordloading] = useState(false);
    const [otpTimer, setOtpTimer] = useState(0);

    const handleChnangempin = (e) => {
        const { name, value } = e.target;
        setChangempin({ ...changempin, [name]: value })
    }
    const handleChnangepassword = (e) => {
        const { name, value } = e.target;
        setChangepassword({ ...changepassword, [name]: value })
    }

    const SentOTP = async (purpose) => {
        if (!purpose) {
            message.error('Purpose is not define');
            return;
        }
        try {
            setotploading(true);
            const data = await Sendotp(purpose);
            if (data.success) {
                message.success('OTP is sent in your registerd mail id');
                setOtpTimer(60); // Start 60 sec countdown
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setotploading(false);
        }

    }
    function Logout_user() {
        localStorage.removeItem('user');
        localStorage.removeItem('expiryTime');
        dispatch({ type: 'LOGOUT' });
        message.success('Logout Successfully', 1.5, () => {
            Navigate('/');
        });

    }
    const handleChangeMPIN_Submit = async () => {
        if (!changempin.newMpin || !changempin.confirmNewMpin || !changempin.otp) {
            message.error('All fields are required');
            return;
        }
        if (changempin.newMpin !== changempin.confirmNewMpin) {
            message.error("Confirm mpin are different");
            return;
        }
        if (changempin.newMpin.length !== 6) {
            message.error('MPIN length should be 6 numbers long');
            return
        }
        try {
            setmpinloading(true);
            const body = {
                newMpin: changempin.newMpin,
                confirmNewMpin: changempin.confirmNewMpin,
                otp: changempin.otp
            }
            const data = await ChangeMpin(body);
            if (data.success) {
                message.success(data.message);
                Logout_user();
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setmpinloading(false);
        }
    }
    const requirements = [
        {
            re: /[A-Z]/,
            label: "Includes at least one uppercase letter",
        },
        {
            re: /[a-z]/,
            label: "Includes at least one lowercase letter",
        },
        {
            re: /\d/,
            label: "Includes at least one number",
        },
        {
            re: /[@$!%*?&]/,
            label: "Includes at least one special character (@$!%*?&)",
        },
    ];
    const getStrength = (password) => {
        let multiplier = password.length >= 8 ? 0 : 1;

        requirements.forEach((requirement) => {
            if (!requirement.re.test(password)) {
                multiplier += 1;
            }
        });

        return Math.max(
            100 - (100 / (requirements.length + 1)) * multiplier,
            0
        );
    };
    function PasswordRequirement({ meets, label }) {
        return (
            <Text
                component="div"
                c={meets ? "teal" : "red"}
                mt={5}
                size="sm"
            >
                <Center inline>
                    {meets ? (
                        <IconCheck size={14} stroke={1.5} />
                    ) : (
                        <IconX size={14} stroke={1.5} />
                    )}
                    <Box ml={7}>{label}</Box>
                </Center>
            </Text>
        );
    }
    const strength = getStrength(changepassword.newPassword);
    const color =
        strength === 100
            ? "teal"
            : strength > 60
                ? "lime"
                : strength > 30
                    ? "yellow"
                    : "red";
    const checks = requirements.map((requirement, index) => (
        <PasswordRequirement
            key={index}
            label={requirement.label}
            meets={requirement.re.test(changepassword.newPassword)}
        />
    ));

    const handleChangePassword_Submit = async () => {
        if (!changepassword.newPassword || !changepassword.confirmNewPassword || !changepassword.otp) {
            message.error('All fields are required');
            return;
        }
        if (changepassword.newPassword !== changepassword.confirmNewPassword) {
            message.error("Confirm password are different");
            return;
        }
        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!passwordRegex.test(changepassword.newPassword)) {
            message.error('Incorrect Password');
            return
        }
        try {
            setpasswordloading(true);
            const body = {
                newPassword: changepassword.newPassword,
                confirmNewPassword: changepassword.confirmNewPassword,
                otp: changepassword.otp
            }
            const data = await ChangePassword(body);
            if (data.success) {
                message.success(data.message);
                Logout_user();
                return;
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setpasswordloading(false);
        }
    }

    useEffect(() => {
        if (otpTimer <= 0) return;

        const interval = setInterval(() => {
            setOtpTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [otpTimer]);
    return (
        <>
            <Topnavbar Headername={'Account Settings'} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Account Settings</Title>
                <Text size="xs">You can change Mpin, Password in account settings.</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 6 }}>
                        <Paper shadow="sm" p={'xs'}>
                            <Text mb={'sm'} fw={500} c={'dimmed'}>Change MPIN</Text>
                            <TextInput label="New MPIN" size="md" withAsterisk maxLength={6} type="password" name="newMpin" value={changempin.newMpin} onChange={handleChnangempin} />
                            <TextInput label="Confirm New MPIN" size="md" withAsterisk mt={'xs'} maxLength={6} name="confirmNewMpin" value={changempin.confirmNewMpin} onChange={handleChnangempin} />
                            <Group justify="space-between" align="end">
                                <TextInput
                                    label="OTP"
                                    placeholder="Enter OTP"
                                    size="sm"
                                    withAsterisk
                                    name="otp"
                                    value={changempin.otp}
                                    onChange={handleChnangempin}
                                    type="password"
                                />

                                {otpTimer > 0 ? (
                                    <Button disabled variant="light">
                                        {`Resend in ${otpTimer}s`}
                                    </Button>
                                ) : (
                                    <Button
                                        loading={otploading}
                                        onClick={() => SentOTP("Change MPIN")}
                                    >
                                        Send OTP
                                    </Button>
                                )}
                            </Group>

                            <Group justify="flex-end" mt="xs">
                                {otpTimer > 0 && (
                                    <Text size="xs" c="dimmed" fw={600}>
                                        Resend OTP in {otpTimer} sec
                                    </Text>
                                )}
                                {/* : (
                                    <Text
                                        size="xs"
                                        fw={700}
                                        c="blue"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => SentOTP("Change MPIN")}
                                    >
                                        Resend OTP
                                    </Text>
                                )} */}
                            </Group>
                            {/* <Group justify="space-between">
                                <TextInput label="OTP" placeholder="" size="sm" withAsterisk mt={'xs'} />
                                <Button mt={'sm'} onClick={() => SentOTP('Change MPIN')} loading={otploading}>Send OTP</Button>
                            </Group>
                            <Group justify="flex-end">
                                <Text size="xs" fw={700}>Resend otp in: </Text>
                            </Group> */}
                            <Button fullWidth variant="light" size="md" mt={'md'} onClick={handleChangeMPIN_Submit} loading={mpinloading}>Change MPIN</Button>
                        </Paper>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 6 }}>
                        <Paper shadow="sm" p={'xs'}>
                            <Text mb={'sm'} fw={500} c={'dimmed'}>Change Password</Text>
                            <TextInput label="New Password" size="md" withAsterisk minLength={8} type="password" name="newPassword" value={changepassword.newPassword} onChange={handleChnangepassword} />
                            {
                                changepassword.newPassword !== '' && (
                                    <>
                                        <Progress
                                            value={strength}
                                            color={color}
                                            size="sm"
                                            mt="xs"
                                            radius="xl"
                                        />

                                        <Text size="xs" mt={5} fw={600}>
                                            Password Strength:{" "}
                                            {strength === 100
                                                ? "Strong"
                                                : strength > 60
                                                    ? "Good"
                                                    : strength > 30
                                                        ? "Weak"
                                                        : "Very Weak"}
                                        </Text>

                                        <PasswordRequirement
                                            label="Has at least 8 characters"
                                            meets={changepassword.newPassword.length >= 8}
                                        />

                                        {checks}
                                    </>
                                )
                            }

                            <TextInput label="Confirm New Password" size="md" withAsterisk mt={'xs'} minLength={8} name="confirmNewPassword" value={changepassword.confirmNewPassword} onChange={handleChnangepassword} />
                            <Group justify="space-between" align="end">
                                <TextInput
                                    label="OTP"
                                    placeholder="Enter OTP"
                                    size="sm"
                                    name="otp"
                                    value={changepassword.otp}
                                    onChange={handleChnangepassword}
                                    withAsterisk
                                    type="password"
                                />

                                {otpTimer > 0 ? (
                                    <Button disabled variant="light">
                                        {`Resend in ${otpTimer}s`}
                                    </Button>
                                ) : (
                                    <Button
                                        loading={otploading}
                                        onClick={() => SentOTP("Change Password")}
                                    >
                                        Send OTP
                                    </Button>
                                )}
                            </Group>

                            <Group justify="flex-end" mt="xs">
                                {otpTimer > 0 && (
                                    <Text size="xs" c="dimmed" fw={600}>
                                        Resend OTP in {otpTimer} sec
                                    </Text>
                                )}
                                {/* : (
                                    <Text
                                        size="xs"
                                        fw={700}
                                        c="blue"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => SentOTP("Change Password")}
                                    >
                                        Resend OTP
                                    </Text>
                                )} */}
                            </Group>
                            <Button fullWidth variant="light" size="md" mt={'md'} loading={passwordloading} onClick={handleChangePassword_Submit}>Change Password</Button>
                        </Paper>
                    </Grid.Col>
                </Grid>

            </Container>
        </>
    )
}
export default Accountsetings;